import { withErrorBoundary } from '@festina-life/ui/libs'
import type { FC, JSX } from 'react'
import type {
  ErrorBoundaryPropsWithComponent,
  ErrorBoundaryPropsWithRender,
} from 'react-error-boundary'

import { LifeErrorFallback } from '../components/errorFallback/LifeErrorFallback'

/**
 * Specializing the withLifeErrorBoundary to use a life specific ErrorFallback
 *
 * @example
 * const ErrorManagedComponent = withLifeErrorBoundary(SomeComponent, {FallbackComponent: () => <Alert message="Something happened"/>})
 * return <ErrorManagedComponent {...someComponentProps} />
 */
export const withLifeErrorBoundary = <T,>(
  WrappedComponent: FC<T>,
  boundaryProps:
    | ErrorBoundaryPropsWithComponent
    | ErrorBoundaryPropsWithRender = {
    FallbackComponent: LifeErrorFallback,
  },
): FC<T & JSX.IntrinsicAttributes> =>
  withErrorBoundary(WrappedComponent, boundaryProps)
